<template>
  <div class="page">
    <f7-navbar title="領袖培育" back-link="Back">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>    

    <div class="page-content">
      <header class="wave-header sticky-top"></header>
      <p class="segmented segmented-round">
        <button class="button button-round button-outline ">申請中</button>        
        <button class="button button-round button-outline button-active">已核可</button>
      </p>
      <div class="list">
        <div class="block-header">108 學年度第 1 學期(補發Ｔ幣)</div>


      </div>
    </div>


  </div>
</template>

<script>
import PopModalTest from "./PopModalTest";

export default {
  components: {},
  data() {
    return {
      checked: true
    };
  },
  created: function() {},
  mounted() {},
  methods: {
    openPrompt: function() {
      this.$dialog.modal({
        component: PopModalTest,
        title: "進階培力",
        showCloseBtn: this.checked,
        // params:{firstInput:"被當了三個學期還是不會"},
        callback: p => {
          this.$dialog.alert("已送出申請要求，記得要送件唷！", {
            type: "success",
            showIcon: false
          });
        }
      });
    },
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/soft-power/soft-power.vue